// Standard React entry point (replaces previous WordPress plugin embedding logic)
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './style.css';
import 'react-google-reviews/dist/index.css';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://c50418b49892f34bbcdd37a9d8272d01@o290751.ingest.us.sentry.io/4511261977018368',
    });
}

// Optional: suppress console.log outside of local/dev style hosts
const devHosts = ["localhost", "127.0.0.1", "test-site.local"];
if (!devHosts.includes(window.location.hostname) && process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element with id 'root' not found. Ensure public/index.html contains <div id=\"root\"></div>");
}

createRoot(rootElement).render(<App />);
